module.exports = __webpack_public_path__ + "img/ph_back.e0d4a5e8.jpg";